<template>
    <div class="main">
    </div>
</template>
<script>
// import func from './func/func.js'
import axios from 'axios'
export default {
  name: 'storeMain',
  data () {
    return {
      searchWord: '',
      eventList: '',
      device: '',
      categoryList: [],
      storeData: [],
      productCount: []
    }
  },
  mounted () {
    history.replaceState({}, null, location.pathname)
  },
  methods: {
    async mountedPage () {
      // 접속기기 체크
      this.device = await chkDevice()
      if (this.device !== 'android') {
        this.eventList = await getStoreData(this.$route.params.url)
        this.storeData = await getStoreInfo(this.eventList.storeSeq)
        if (!this.$empty(this.eventList.categoryList)) {
          for (let i = 0; i < this.eventList.categoryList.length; i++) {
            var data = await getCategoryList(this.eventList.storeSeq, this.eventList.categoryList[i].categorySeq)
            var delivery = await this.getStoreDeliveryInfo(this.eventList.storeSeq)
            this.categoryList.push(data)
            if (this.$store.state.deliveryInfo.findIndex(x => x.STORE_SEQ === delivery.STORE_SEQ) !== -1) {
              this.$store.state.storeDeliveryInfo = this.$_.cloneDeep(delivery)
            } else {
              console.log('배달정보 중복있음')
            }
          }
        }
      } else {
        this.$router.push('selectApp')
      }
      function chkDevice () {
        var device = navigator.userAgent.toLowerCase()
        var result = ''
        return new Promise((resolve, reject) => {
          if (device.match('iphone') || device.match('ipad') || device.match('ipod')) {
            // 아이폰
            result = 'ios'
            resolve(result)
          } else if (device.match('android')) {
            // 안드로이드 기기
            result = 'android'
            resolve(result)
          } else {
            // 그 외
            result = 'pc'
            resolve(result)
          }
        })
      }
      function getStoreData (url) {
        // const vm = this
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: `${process.env.API}/getEvent/${url}`
          })
            .then((response) => {
              // console.log(response.data)
              // this.eventList = this.$_.cloneDeep(response.data)
              // var tmp = this.$_.cloneDeep(response.data)
              resolve(JSON.parse(response.data.event))
            })
        })
      }
      function getCategoryList (store, seq) {
        console.log('storeSeq:::', store)
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: `${process.env.API}/getCategoryList/store/${store}/seq/${seq}`
          })
            .then((response) => {
              resolve(response.data[0])
            })
        })
      }
      function getStoreInfo (store) {
        console.log('err')
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: `${process.env.API}/getStoreInfo/store/${store}`
          })
            .then((response) => {
              resolve(response.data[0])
            })
        })
      }
      // function getStoreDeliveryInfo (store) {
      //   return new Promise((resolve, reject) => {
      //     axios({
      //       method: 'get',
      //       url: `${process.env.API}/getStoreDeliveryInfo/store/${store}`
      //     })
      //       .then((response) => {
      //         resolve(response.data[0])
      //       })
      //   })
      // }
    },
    clearSearch () {
      this.searchWord = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('/css/main.scss');
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue